import { render, staticRenderFns } from "./SupplementComponent.vue?vue&type=template&id=0db582b8&scoped=true"
import script from "./SupplementComponent.vue?vue&type=script&lang=js"
export * from "./SupplementComponent.vue?vue&type=script&lang=js"
import style0 from "./SupplementComponent.vue?vue&type=style&index=0&id=0db582b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db582b8",
  null
  
)

export default component.exports